// extracted by mini-css-extract-plugin
export default {"content":"info_content__nA4PX"};